/**
 * 订单管理
 */
 import Layout from '../../pages/layout/Frame';

 const orderManageRouter = {
     path: "/orderManage",
     component: Layout,
     meta: {title: '订单管理'},
     name: "orderManage",
     children: [
         {
             path: "/orderManage/index",
             component: () => import('../../pages/orderManage/index'),
             meta: {title: '订单管理',},
             name: 'orderManage',
         },
         {
            path: "/orderManage/detail",
            component: () => import('../../pages/orderManage/detail'),
            meta: {title: '订单详情',},
            name: 'orderManage',
        },
     ]
 };
 
 export default orderManageRouter
 